import { render, staticRenderFns } from "./threeD.vue?vue&type=template&id=ae79452a&scoped=true"
import script from "./threeD.vue?vue&type=script&lang=js"
export * from "./threeD.vue?vue&type=script&lang=js"
import style0 from "./threeD.vue?vue&type=style&index=0&id=ae79452a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae79452a",
  null
  
)

export default component.exports